module.exports = __webpack_public_path__ + "img/product-icon.7256c9a5.svg";